
import toast from "react-hot-toast";
import { SETTING_COUPON_ADD, SETTING_COUPON_ADD_FAIL, SETTING_COUPON_ADD_SUCCESS, SETTING_COUPON_DELETE, SETTING_COUPON_DELETE_FAIL, SETTING_COUPON_DELETE_SUCCESS, SETTING_COUPON_EDIT, SETTING_COUPON_EDIT_FAIL, SETTING_COUPON_EDIT_SUCCESS, SETTING_COUPON_LIST, SETTING_COUPON_LIST_FAIL, SETTING_COUPON_LIST_SUCCESS, SETTING_DECLARATIONS_ADD, SETTING_DECLARATIONS_ADD_FAIL, SETTING_DECLARATIONS_ADD_SUCCESS, SETTING_DECLARATIONS_DELETE, SETTING_DECLARATIONS_DELETE_FAIL, SETTING_DECLARATIONS_DELETE_SUCCESS, SETTING_DECLARATIONS_EDIT, SETTING_DECLARATIONS_EDIT_FAIL, SETTING_DECLARATIONS_EDIT_SUCCESS, SETTING_DECLARATIONS_LIST, SETTING_DECLARATIONS_LIST_FAIL, SETTING_DECLARATIONS_LIST_SUCCESS, SETTING_LOCKER_ADD, SETTING_LOCKER_ADD_FAIL, SETTING_LOCKER_ADD_SUCCESS, SETTING_LOCKER_DELETE, SETTING_LOCKER_DELETE_FAIL, SETTING_LOCKER_DELETE_SUCCESS, SETTING_LOCKER_EDIT, SETTING_LOCKER_EDIT_FAIL, SETTING_LOCKER_EDIT_SUCCESS, SETTING_LOCKER_LIST, SETTING_LOCKER_LIST_FAIL, SETTING_LOCKER_LIST_SUCCESS, SETTING_NOTIFICATION_ADD, SETTING_NOTIFICATION_ADD_FAIL, SETTING_NOTIFICATION_ADD_SUCCESS, SETTING_NOTIFICATION_DELETE, SETTING_NOTIFICATION_DELETE_FAIL, SETTING_NOTIFICATION_DELETE_SUCCESS, SETTING_NOTIFICATION_EDIT, SETTING_NOTIFICATION_EDIT_FAIL, SETTING_NOTIFICATION_EDIT_SUCCESS, SETTING_NOTIFICATION_LIST, SETTING_NOTIFICATION_LIST_FAIL, SETTING_NOTIFICATION_LIST_SUCCESS, SHIPPING_PARTNER_ADD, SHIPPING_PARTNER_ADD_FAIL, SHIPPING_PARTNER_ADD_SUCCESS, SHIPPING_PARTNER_DELETE, SHIPPING_PARTNER_DELETE_FAIL, SHIPPING_PARTNER_DELETE_SUCCESS, SHIPPING_PARTNER_EDIT, SHIPPING_PARTNER_EDIT_FAIL, SHIPPING_PARTNER_EDIT_SUCCESS, SHIPPING_PARTNER_LIST, SHIPPING_PARTNER_LIST_FAIL, SHIPPING_PARTNER_LIST_SUCCESS, SHOPPER_PRICE_ADD, SHOPPER_PRICE_ADD_FAIL, SHOPPER_PRICE_ADD_SUCCESS, SHOPPER_PRICE_DELETE, SHOPPER_PRICE_DELETE_FAIL, SHOPPER_PRICE_DELETE_SUCCESS, SHOPPER_PRICE_EDIT, SHOPPER_PRICE_EDIT_FAIL, SHOPPER_PRICE_EDIT_SUCCESS, SHOPPER_PRICE_LIST, SHOPPER_PRICE_LIST_FAIL, SHOPPER_PRICE_LIST_SUCCESS } from "../../actions/admin/customer-actions";

const initialState = {
    isLoading: false,
    isError: false,
    isSuccess: false,
    message: "",
    totalPages: 0,
    total: 0,
    shippingPartner: {},
    coupons: {},
    declarations: {},
    notification: {},
    lockerData:{},
    shopperPricing:{},
    
};

const settingDataReducer = (state = initialState, { type, payload }) => {
    switch (type) {
        case SHIPPING_PARTNER_ADD: {
            return {
                ...state,
                isLoading: true,
            };
        }
        case SHIPPING_PARTNER_ADD_SUCCESS: {
            toast.success(payload?.message);
            return {
                ...state,
                isLoading: false,
            };
        }
        case SHIPPING_PARTNER_ADD_FAIL: {
            toast.error(payload?.error?.data?.message);
            return {
                ...state,
                isLoading: false,
            };
        }

        case SHIPPING_PARTNER_EDIT: {
            return {
                ...state,
                isLoading: true,
            };
        }
        case SHIPPING_PARTNER_EDIT_SUCCESS: {
            toast.success(payload?.message);
            return {
                ...state,
                isLoading: false,
            };
        }
        case SHIPPING_PARTNER_EDIT_FAIL: {
            toast.error(payload?.error?.data?.message);
            return {
                ...state,
                isLoading: false,
            };
        }

        case SHIPPING_PARTNER_DELETE: {
            return {
                ...state,
                isLoading: true,
            };
        }
        case SHIPPING_PARTNER_DELETE_SUCCESS: {
            toast.success(payload?.message);
            return {
                ...state,
                isLoading: false,
            };
        }
        case SHIPPING_PARTNER_DELETE_FAIL: {
            toast.error(payload?.error?.data?.message);
            return {
                ...state,
                isLoading: false,
            };
        }

        case SHIPPING_PARTNER_LIST: {
            return {
                ...state,
                isLoading: true,
            };
        }
        case SHIPPING_PARTNER_LIST_SUCCESS: {
            return {
                ...state,
                shippingPartner: payload.data,
                isLoading: false,
            };
        }
        case SHIPPING_PARTNER_LIST_FAIL: {
            return {
                ...state,
                isLoading: false,
            };
        }

        case SETTING_COUPON_ADD: {
            return {
                ...state,
                isLoading: true,
            };
        }
        case SETTING_COUPON_ADD_SUCCESS: {
            toast.success(payload?.message);
            return {
                ...state,
                isLoading: false,
            };
        }
        case SETTING_COUPON_ADD_FAIL: {
            toast.error(payload?.error?.data?.message);
            return {
                ...state,
                isLoading: false,
            };
        }

        case SETTING_COUPON_EDIT: {
            return {
                ...state,
                isLoading: true,
            };
        }
        case SETTING_COUPON_EDIT_SUCCESS: {
            toast.success(payload?.message);
            return {
                ...state,
                isLoading: false,
            };
        }
        case SETTING_COUPON_EDIT_FAIL: {
            toast.error(payload?.error?.data?.message);
            return {
                ...state,
                isLoading: false,
            };
        }

        case SETTING_COUPON_DELETE: {
            return {
                ...state,
                isLoading: true,
            };
        }
        case SETTING_COUPON_DELETE_SUCCESS: {
            toast.success(payload?.message);
            return {
                ...state,
                isLoading: false,
            };
        }
        case SETTING_COUPON_DELETE_FAIL: {
            toast.error(payload?.error?.data?.message);
            return {
                ...state,
                isLoading: false,
            };
        }

        case SETTING_COUPON_LIST: {
            return {
                ...state,
                isLoading: true,
            };
        }
        case SETTING_COUPON_LIST_SUCCESS: {
            return {
                ...state,
                coupons: payload.data,
                isLoading: false,
            };
        }
        case SETTING_COUPON_LIST_FAIL: {
            return {
                ...state,
                isLoading: false,
            };
        }
        case SETTING_DECLARATIONS_ADD: {
            return {
                ...state,
                isLoading: true,
            };
        }
        case SETTING_DECLARATIONS_ADD_SUCCESS: {
            toast.success(payload?.message);
            return {
                ...state,
                isLoading: false,
            };
        }
        case SETTING_DECLARATIONS_ADD_FAIL: {
            toast.error(payload?.error?.data?.message);
            return {
                ...state,
                isLoading: false,
            };
        }

        case SETTING_DECLARATIONS_EDIT: {
            return {
                ...state,
                isLoading: true,
            };
        }
        case SETTING_DECLARATIONS_EDIT_SUCCESS: {
            toast.success(payload?.message);
            return {
                ...state,
                isLoading: false,
            };
        }
        case SETTING_DECLARATIONS_EDIT_FAIL: {
            toast.error(payload?.error?.data?.message);
            return {
                ...state,
                isLoading: false,
            };
        }

        case SETTING_DECLARATIONS_DELETE: {
            return {
                ...state,
                isLoading: true,
            };
        }
        case SETTING_DECLARATIONS_DELETE_SUCCESS: {
            toast.success(payload?.message);
            return {
                ...state,
                isLoading: false,
            };
        }
        case SETTING_DECLARATIONS_DELETE_FAIL: {
            toast.error(payload?.error?.data?.message);
            return {
                ...state,
                isLoading: false,
            };
        }

        case SETTING_DECLARATIONS_LIST: {
            return {
                ...state,
                isLoading: true,
            };
        }
        case SETTING_DECLARATIONS_LIST_SUCCESS: {
            return {
                ...state,
                declarations: payload.data,
                isLoading: false,
            };
        }
        case SETTING_DECLARATIONS_LIST_FAIL: {
            return {
                ...state,
                isLoading: false,
            };
        }
        case SETTING_NOTIFICATION_ADD: {
            return {
                ...state,
                isLoading: true,
            };
        }
        case SETTING_NOTIFICATION_ADD_SUCCESS: {
            toast.success(payload?.message);
            return {
                ...state,
                isLoading: false,
            };
        }
        case SETTING_NOTIFICATION_ADD_FAIL: {
            toast.error(payload?.error?.data?.message);
            return {
                ...state,
                isLoading: false,
            };
        }

        case SETTING_NOTIFICATION_EDIT: {
            return {
                ...state,
                isLoading: true,
            };
        }
        case SETTING_NOTIFICATION_EDIT_SUCCESS: {
            toast.success(payload?.message);
            return {
                ...state,
                isLoading: false,
            };
        }
        case SETTING_NOTIFICATION_EDIT_FAIL: {
            toast.error(payload?.error?.data?.message);
            return {
                ...state,
                isLoading: false,
            };
        }

        case SETTING_NOTIFICATION_DELETE: {
            return {
                ...state,
                isLoading: true,
            };
        }
        case SETTING_NOTIFICATION_DELETE_SUCCESS: {
            toast.success(payload?.message);
            return {
                ...state,
                isLoading: false,
            };
        }
        case SETTING_NOTIFICATION_DELETE_FAIL: {
            toast.error(payload?.error?.data?.message);
            return {
                ...state,
                isLoading: false,
            };
        }

        case SETTING_NOTIFICATION_LIST: {
            return {
                ...state,
                isLoading: true,
            };
        }
        case SETTING_NOTIFICATION_LIST_SUCCESS: {
            return {
                ...state,
                notification: payload.data,
                isLoading: false,
            };
        }
        case SETTING_NOTIFICATION_LIST_FAIL: {
            return {
                ...state,
                isLoading: false,
            };
        }

        // lockter items start
        case SETTING_LOCKER_ADD: {
                return {
            ...state,
            isLoading: true,
        };
        }
        case SETTING_LOCKER_ADD_SUCCESS: {
            toast.success(payload?.message);
            return {
                ...state,
                isLoading: false,
            };
        }
        case SETTING_LOCKER_ADD_FAIL: {
            toast.error(payload?.error?.data?.message);
            return {
                ...state,
                isLoading: false,
            };
        }

        case SETTING_LOCKER_EDIT: {
            return {
                ...state,
                isLoading: true,
            };
        }
        case SETTING_LOCKER_EDIT_SUCCESS: {
            toast.success(payload?.message);
            return {
                ...state,
                isLoading: false,
            };
        }
        case SETTING_LOCKER_EDIT_FAIL: {
            toast.error(payload?.error?.data?.message);
            return {
                ...state,
                isLoading: false,
            };
        }

        case SETTING_LOCKER_DELETE: {
            return {
                ...state,
                isLoading: true,
            };
        }
        case SETTING_LOCKER_DELETE_SUCCESS: {
            toast.success(payload?.message);
            return {
                ...state,
                isLoading: false,
            };
        }
        case SETTING_LOCKER_DELETE_FAIL: {
            toast.error(payload?.error?.data?.message);
            return {
                ...state,
                isLoading: false,
            };
        }

        case SETTING_LOCKER_LIST: {
            return {
                ...state,
                isLoading: true,
            };
        }
        case SETTING_LOCKER_LIST_SUCCESS: {
            return {
                ...state,
                lockerData: payload.data,
                isLoading: false,
            };
        }
        case SETTING_LOCKER_LIST_FAIL: {
            return {
                ...state,
                isLoading: false,
            };
        }

        //Shopper Pricing start
        case SHOPPER_PRICE_ADD: {
                return {
            ...state,
            isLoading: true,
        };
        }
        case SHOPPER_PRICE_ADD_SUCCESS: {
            toast.success(payload?.message);
            return {
                ...state,
                isLoading: false,
            };
        }
        case SHOPPER_PRICE_ADD_FAIL: {
            toast.error(payload?.error?.data?.message);
            return {
                ...state,
                isLoading: false,
            };
        }

        case SHOPPER_PRICE_EDIT: {
            return {
                ...state,
                isLoading: true,
            };
        }
        case SHOPPER_PRICE_EDIT_SUCCESS: {
            toast.success(payload?.message);
            return {
                ...state,
                isLoading: false,
            };
        }
        case SHOPPER_PRICE_EDIT_FAIL: {
            toast.error(payload?.error?.data?.message);
            return {
                ...state,
                isLoading: false,
            };
        }

        case SHOPPER_PRICE_DELETE: {
            return {
                ...state,
                isLoading: true,
            };
        }
        case SHOPPER_PRICE_DELETE_SUCCESS: {
            toast.success(payload?.message);
            return {
                ...state,
                isLoading: false,
            };
        }
        case SHOPPER_PRICE_DELETE_FAIL: {
            toast.error(payload?.error?.data?.message);
            return {
                ...state,
                isLoading: false,
            };
        }

        case SHOPPER_PRICE_LIST: {
            return {
                ...state,
                isLoading: true,
            };
        }
        case SHOPPER_PRICE_LIST_SUCCESS: {
            return {
                ...state,
                shopperPricing: payload.data,
                isLoading: false,
            };
        }
        case SHOPPER_PRICE_LIST_FAIL: {
            return {
                ...state,
                isLoading: false,
            };
        }
        default: {
            return { ...state };
        }
    }
};

export default settingDataReducer;
